import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon27: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M2.92875 2.92875C6.83475 -0.97625 13.1667 -0.97625 17.0727 2.92875C20.9777 6.83375 20.9777 13.1657 17.0727 17.0707C13.1667 20.9757 6.83475 20.9757 2.92875 17.0707C-0.97625 13.1657 -0.97625 6.83375 2.92875 2.92875ZM16.3648 3.63575C12.8508 0.120751 7.15073 0.120751 3.63673 3.63575C0.121727 7.15075 0.121727 12.8487 3.63673 16.3637C7.15073 19.8787 12.8508 19.8787 16.3648 16.3637C19.8798 12.8487 19.8798 7.15075 16.3648 3.63575ZM10.5007 4.99975C10.7767 4.99975 11.0007 5.22375 11.0007 5.49975V10.4997C11.0007 10.7757 10.7767 10.9997 10.5007 10.9997H5.50074C5.22474 10.9997 5.00074 10.7757 5.00074 10.4997C5.00074 10.2237 5.22474 9.99975 5.50074 9.99975H10.0007V5.49975C10.0007 5.22375 10.2247 4.99975 10.5007 4.99975Z"
        fill="#32BBC3"
      />
    </Icon>
  )
}
